import { BuildConfig } from '../config/BuildConfig'

export const LedModule = {
  partNumber: BuildConfig.brand.ledModuleItemNo, // 40MLEDW
  name: 'LED Module',
} as const